// extracted by mini-css-extract-plugin
module.exports = {"mainBackContent":"index_mainBackContent__jDvYk","mainContent":"index_mainContent__nONVD"};